export const ORG_MEMBER_ROLES = ["org_admin", "staff"] as const;
export type OrgMemberRole = (typeof ORG_MEMBER_ROLES)[number];

export const ORG_ROLE_LABELS: Record<OrgMemberRole, string> = {
  org_admin: "Admin",
  staff: "Staff",
};

/** Higher rank = more privilege. Used for "at least this role" checks. */
export const ORG_ROLE_RANK: Record<OrgMemberRole, number> = {
  staff: 1,
  org_admin: 2,
};

export const ORG_KINDS = ["hospital", "school", "other"] as const;
export type OrgKind = (typeof ORG_KINDS)[number];

export const ORG_KIND_LABELS: Record<OrgKind, string> = {
  hospital: "Hospital",
  school: "School",
  other: "Organization",
};

/**
 * The word an org uses for the people it tracks. Drives UI copy so the same
 * generic model reads correctly per institution type
 * (hospital → "patient", school → "student", family → "child").
 */
export const ORG_SUBJECT_NOUN: Record<OrgKind, string> = {
  hospital: "patient",
  school: "student",
  other: "record",
};
